export const modulo = (n, mod) => ((n % mod) + mod) % mod;
